import { useState, useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import { getSession } from "./lib/session";
import { ThemeProvider } from "./hooks/use-theme";

const queryClient = new QueryClient();

const App = () => {
  const [userData, setUserData] = useState<any>(undefined);

  useEffect(() => {
    // Leemos dentro del efecto para garantizar que el storage esté disponible
    // (crítico en WebViews de Android/iOS donde el acceso síncrono puede fallar)
    getSession().then((session) => setUserData(session));
  }, []);

  // Mientras no sabemos si hay sesión, no renderizamos nada (evita flash)
  if (userData === undefined) return null;

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={userData && userData.id ? <Home /> : <Login />} />
              <Route path="/home" element={<Home />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
